/**
 * @desc 根据id下载报告
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.monthlyReport.getDownloadReport.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/monthlyReport/downloadReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
